import * as RxFactory from './api/rx-factory'
import * as Endpoints from './api/endpoints'

export const downloadDocs = (qParams) => {
    window.open(Endpoints.DOWNLOAD_DOCS + qParams)
}

export function _messageDisplayFunction(getParameter,getMessage,msgType){
    getParameter.response_msg = getMessage
    getParameter.msg_type = msgType
}


// WEBPACK FOOTER //
// ./src/store/commonFunctions.js